import React from 'react';
import { Card, Row, Col, Statistic, Space, Button, Table, Tag, message } from 'antd';
import { ReloadOutlined, SyncOutlined } from '@ant-design/icons';
import axios from 'axios';

function authHeader() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export default function Operations({ user }) {
  const [loading, setLoading] = React.useState(false);
  const [runtime, setRuntime] = React.useState({ settings: [], recent_audit: [], recent_incidents: [] });

  const loadRuntime = React.useCallback(async () => {
    try {
      setLoading(true);
      const res = await axios.get('/api/ops/runtime', { headers: authHeader() });
      setRuntime(res.data || { settings: [], recent_audit: [], recent_incidents: [] });
    } catch {
      message.error('No se pudo cargar operacion');
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    loadRuntime();
  }, [loadRuntime]);

  const reconcileIncidents = async () => {
    try {
      setLoading(true);
      const res = await axios.post('/api/ops/incidents/reconcile', {}, { headers: authHeader() });
      message.success(res.data?.message || 'Reconciliacion ejecutada');
      await loadRuntime();
    } catch (err) {
      message.error(err.response?.data?.error || 'No se pudo reconciliar incidentes');
    } finally {
      setLoading(false);
    }
  };

  const incidentColumns = [
    { title: 'Key', dataIndex: 'incident_key', key: 'incident_key' },
    { title: 'Severidad', dataIndex: 'severity', key: 'severity', render: (v) => <Tag color={v === 'critical' ? 'red' : v === 'warning' ? 'gold' : 'blue'}>{v}</Tag> },
    { title: 'Mensaje', dataIndex: 'message', key: 'message' },
    { title: 'Estado', key: 'state', render: (_, r) => (r.is_active ? <Tag color="red">ACTIVO</Tag> : <Tag color="green">RESUELTO</Tag>) }
  ];

  const auditColumns = [
    { title: 'Usuario', dataIndex: 'username', key: 'username', width: 140 },
    { title: 'Accion', dataIndex: 'action', key: 'action', width: 120 },
    { title: 'Entidad', dataIndex: 'entity', key: 'entity', width: 140 },
    { title: 'Detalle', dataIndex: 'details', key: 'details' },
    { title: 'Fecha', dataIndex: 'created_at', key: 'created_at', width: 170 }
  ];

  return (
    <div>
      <h1 style={{ marginBottom: 20 }}>Operacion</h1>
      <Space style={{ marginBottom: 16 }}>
        <Button icon={<ReloadOutlined />} onClick={loadRuntime} loading={loading}>Actualizar</Button>
        {user?.role === 'admin' && (
          <Button type="primary" icon={<SyncOutlined />} onClick={reconcileIncidents} loading={loading}>Reconciliar Incidentes</Button>
        )}
      </Space>

      <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
        <Col xs={24} sm={8}><Card><Statistic title="MQTT" value={runtime?.mqtt_connected ? 'Conectado' : 'Desconectado'} valueStyle={{ color: runtime?.mqtt_connected ? '#16a34a' : '#dc2626' }} /></Card></Col>
        <Col xs={24} sm={8}><Card><Statistic title="PID" value={runtime?.runtime?.pid || 0} /></Card></Col>
        <Col xs={24} sm={8}><Card><Statistic title="Uptime Proceso (s)" value={runtime?.runtime?.process_uptime_sec || 0} /></Card></Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card title="Incidentes Recientes">
            <Table rowKey="id" columns={incidentColumns} dataSource={runtime?.recent_incidents || []} pagination={{ pageSize: 5 }} scroll={{ x: 700 }} />
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card title="Auditoria Reciente">
            <Table rowKey="id" columns={auditColumns} dataSource={runtime?.recent_audit || []} pagination={{ pageSize: 5 }} scroll={{ x: 800 }} />
          </Card>
        </Col>
      </Row>
    </div>
  );
}
